import { render, staticRenderFns } from "./ClientContactHistory.vue?vue&type=template&id=32d9694e&scoped=true&"
import script from "./ClientContactHistory.vue?vue&type=script&lang=js&"
export * from "./ClientContactHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d9694e",
  null
  
)

export default component.exports